import React from 'react';
import PropTypes from 'prop-types';
import TalScenes from '../solution/TalAiScenes';
import less from './ApplicationScenarios.less';

class ApplicationScenarios extends React.Component {
  render() {
    return (
      <div className={less.applicationScenarios}>
        <div className={less.top}>{this.props.title}</div>
        <div className={less.bottom}>
          <div className={less.bottomCon}>
            <TalScenes type="product" contents={this.props.contents} />
          </div>
        </div>
      </div>
    );
  }
}

ApplicationScenarios.propTypes = {
  title: PropTypes.string,
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      desc: PropTypes.string,
      image: PropTypes.string
    })
  )
};

export default ApplicationScenarios;
